import { useQuery } from '@tanstack/react-query';
import { companiesService } from '@aslanpay/portal-common-lib';

import { CompanySearchResult } from 'app/components/CommandPalette/types';

const useSearchCompanies = (query: string, enabled = true) => {
  return useQuery<CompanySearchResult[], Error>(
    ['searchCompanies', query],
    async () => {
      if (!query || query.length < 3) {
        return [];
      }

      const companies = await companiesService.fetchCompanies({
        query,
        page: 0,
        size: 20,
      });

      return companies.list.map((company) => ({
        id: company.id,
        name: company.name,
        status: company.status,
        friendlyId: company.friendlyId,
      }));
    },
    {
      enabled: enabled && query.length >= 3,
      staleTime: 30000,
      retry: false,
    }
  );
};

export default useSearchCompanies;
